/* src/app/modules/taxes/model-180/model-180-recipients/model-180-recipients.component.css */
:host {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.r180-declarante {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 32px;
  padding: 10px 16px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
  font-size: 13px;
  color: var(--cf-text);
}
.r180-resumen {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.r180-resumen__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 16px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
  font-size: 15px;
  color: var(--cf-text);
}
.r180-resumen__item--error strong {
  color: var(--cf-error);
}
.r180-resumen__label {
  font-size: 12px;
  color: var(--cf-text-muted);
}
.r180-estado {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--cf-success);
}
.r180-estado--error {
  color: var(--cf-error);
}
.r180-estado mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.r180-filtros {
  display: flex;
  align-items: center;
  gap: 8px;
}
.r180-filtros ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
.r180-filtros ::ng-deep app-select {
  width: 190px;
}
@media (max-width: 992px) {
  .r180-resumen {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.r180-filtros ::ng-deep .qf-search {
  height: 36px;
  width: 220px;
  padding: 0 10px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  background: #fff;
  font-size: 13px;
  box-sizing: border-box;
  outline: none;
}
.r180-filtros ::ng-deep .qf-search:focus {
  border-color: var(--cf-brand-dark);
}
.r180-origen {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--cf-text-muted);
}
.r180-origen--manual {
  color: var(--cf-brand-dark);
  font-weight: 600;
}
.r180-origen mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
/*# sourceMappingURL=model-180-recipients.component.css.map */
